/**
 * Interfaces to handle the Authentication
 */

import {ISession} from "@/types/ISession";

/**
 * Interfaces to handle the Installments response and components
 * @property {string} deviceTag - Device Identifier on FEv2
 * @property {string} sharedSecret - Shared Password on Middleware
 */
export interface ILoginCredentials {
  deviceTag: string;
  sharedSecret: string;
  optionName: string;
  product?: string;
}

/**
 * Interfaces to handle the Login JWT tokens and session
 * @property {string} access - Access Token
 * @property {string} refresh - Refresh Token
 *
 * @property {ISession} session - Session
 */
export interface IAuthResponse {
  access: string;
  refresh: string;
  session: ISession;
}

/**
 * Interfaces to handle the Authentication error responses
 * @property {number} statusCode - Status Code
 * @property {any} response - Response
 * @property {string} message - Error Message
 * @property {string} name - Class Name
 */
export class IAuthError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public response?: any
  ) {
    super(message);
    this.name = "IAuthError";
  }
}
